import React from 'react';
import dateTimeFormat from "mrf/utils/DateTimeFormatter";
import {useTranslation} from 'react-i18next';
import PageTitle from "mrf/view/Title";
import QueryObjectTable from "mrf/view/QueryObjectTable";
import Button from "mrf/view/Button";
import {daoPost} from "mrf/Dao";
import notification, {TYPE} from "mrf/utils/notification";
import {setFormValueAction} from "mrf/redux/actions/form";
import {useDispatch} from 'react-redux';
import { Grid, Col } from 'mrf/view/Grid';

export default function CommunicationKeyPairList({ match }) {

    const {t} = useTranslation();

    const fields = [
        {name: t('Key Id'), key: 'keyId'},
        {name: t('Purpose'), key: 'purpose', map: t},
        {name: t('Record Timestamp'), key: 'recordTimestamp', map: dateTimeFormat},
        {name: t('Expiration Timestamp'), key: 'expirationTimestamp', map: dateTimeFormat},
        {name: t('Status'), key: 'status', map: t}
    ];

    const dispatch = useDispatch();

    const handleNewKeyPair = async () => {
        if (window.confirm(t('Are you sure you wish to create a new key pair? This will revoke any existing ones!'))) {
            await daoPost('api/communicationKeyPairs', '');
            notification({type: TYPE.SUCCESS, message: 'New key pair was successfully created.'});
            dispatch(setFormValueAction('communicationKeyPairsQuery', {fetch: true}));
        }
    }

    return <Grid>
        <Col>
            <PageTitle>Key Pairs</PageTitle>
            <QueryObjectTable resource='communicationKeyPairs' fields={fields}/>
        </Col>
        <Col size={12}>
            <div className="mt-6 flex justify-end gap-4">
                <Button onClick={handleNewKeyPair} width="fit-content" className='shadow' color='primary' marginTop='2'>{t('New Key Pair')}</Button>
            </div>
        </Col>
    </Grid>
};